import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
`;

export const HeaderSection = styled.section`
  display: flex;
  padding: 2rem;
  justify-content: space-between;
`;

export const SectionBodyContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 1rem 4rem;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
`;

export const ContainerSeachData = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerSearce = styled.div`
  display: flex;
  align-items: center;
  & > p {
    margin: 0;
    color: #123559;
    margin-right: 1rem;
  }
`;
export const SearchInput = styled.input`
  border: none;
  border-radius: 2rem;
  padding: 0.5rem 1rem;
  outline: none;
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    font-size: 0.75rem;
    color: #ddd;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    font-size: 0.75rem;
    color: #ddd;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    font-size: 0.75rem;
    color: #ddd;
  }
  :-moz-placeholder {
    /* Firefox 18- */
    font-size: 0.75rem;
    color: #ddd;
  }
`;
